<template>
  <div class="main">
    <div class="b-nav">
      <img src="../assets/imgs/spec/icon_home.png" alt="">
      <div class="location">您当前所在的位置:</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>意见建议直通车</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="feedback-wrap">
      <div class="feedback-container">
        <div class="message-top-banner">
          <img src="../assets/imgs/index/message_top.png" alt="意见建议直通车">
        </div>
        <div class="form-card">
        <div class="form-title">
          <i class="el-icon-edit-outline"></i>
          <span>填写问题反馈或意见建议</span>
        </div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="0"
          class="feedback-form"
        >
          <el-form-item prop="type">
            <div class="field-with-star">
              <span class="req-star">*</span>
              <el-input
                v-model="form.type"
                disabled
                class="field-control type-readonly"
              />
            </div>
          </el-form-item>
          <el-form-item prop="title">
            <div class="field-with-star">
              <span class="req-star">*</span>
              <el-input
                v-model="form.title"
                class="field-control"
                placeholder="请输入标题"
                maxlength="255"
                show-word-limit
              />
            </div>
          </el-form-item>
          <el-form-item prop="content">
            <div class="field-with-star field-with-star--textarea">
              <span class="req-star">*</span>
              <el-input
                v-model="form.content"
                class="field-control"
                type="textarea"
                :rows="8"
                placeholder="请输入您的具体内容......"
              />
            </div>
          </el-form-item>
          <el-form-item prop="name">
            <div class="field-with-star">
              <span class="req-star">*</span>
              <el-input
                v-model="form.name"
                class="field-control"
                placeholder="姓名"
                maxlength="50"
              />
            </div>
          </el-form-item>
          <el-form-item prop="phone">
            <div class="field-with-star">
              <span class="req-star">*</span>
              <el-input
                v-model="form.phone"
                class="field-control"
                placeholder="手机"
                maxlength="30"
              />
            </div>
          </el-form-item>
          <el-form-item prop="address">
            <div class="field-with-star">
              <span class="req-star">*</span>
              <el-input
                v-model="form.address"
                class="field-control"
                placeholder="地址"
                maxlength="255"
              />
            </div>
          </el-form-item>
          <el-form-item prop="captchaInput" class="captcha-row">
            <div class="captcha-inner">
              <span class="req-star">*</span>
              <el-input
                v-model="form.captchaInput"
                placeholder="请输入右边的验证码"
                class="captcha-input field-control"
                maxlength="6"
                @keyup.enter.native="onSubmit"
              />
              <canvas
                ref="captchaCanvas"
                class="captcha-canvas"
                width="100"
                height="40"
                title="点击刷新"
                @click="refreshCaptcha"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="submit-btn"
              :loading="submitting"
              @click="onSubmit"
            >
              确定提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { submitMessage } from '../api'

export default {
  name: 'Feedback',
  data() {
    const requireMsg = (field) => (rule, value, callback) => {
      if (value === undefined || value === null || String(value).trim() === '') {
        callback(new Error(`请填写${field}`))
      } else {
        callback()
      }
    }
    return {
      submitting: false,
      captchaCode: '',
      form: {
        type: '意见反馈',
        title: '',
        content: '',
        name: '',
        phone: '',
        address: '',
        captchaInput: ''
      },
      rules: {
        type: [{ validator: requireMsg('类型'), trigger: 'change' }],
        title: [{ validator: requireMsg('标题'), trigger: 'blur' }],
        content: [{ validator: requireMsg('内容'), trigger: 'blur' }],
        name: [{ validator: requireMsg('姓名'), trigger: 'blur' }],
        phone: [
          { validator: requireMsg('手机'), trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error('请填写手机'))
                return
              }
              if (!/^1\d{10}$/.test(String(value).trim())) {
                callback(new Error('请输入正确的手机号码'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        address: [{ validator: requireMsg('地址'), trigger: 'blur' }],
        captchaInput: [
          {
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error('请输入验证码'))
                return
              }
              if (String(value).trim().toLowerCase() !== String(this.captchaCode).toLowerCase()) {
                callback(new Error('验证码不正确'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('changeNum', 1)
    window.scroll(0, 0)
    this.$nextTick(() => {
      this.refreshCaptcha()
    })
  },
  methods: {
    refreshCaptcha() {
      const chars = '0123456789'
      let code = ''
      for (let i = 0; i < 4; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.captchaCode = code
      const canvas = this.$refs.captchaCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const w = canvas.width
      const h = canvas.height
      ctx.fillStyle = '#f5f5f5'
      ctx.fillRect(0, 0, w, h)
      ctx.strokeStyle = '#cccccc'
      ctx.strokeRect(0, 0, w, h)
      for (let i = 0; i < 6; i++) {
        ctx.strokeStyle = `rgba(${Math.floor(Math.random() * 200)},${Math.floor(Math.random() * 200)},${Math.floor(Math.random() * 200)},0.4)`
        ctx.beginPath()
        ctx.moveTo(Math.random() * w, Math.random() * h)
        ctx.lineTo(Math.random() * w, Math.random() * h)
        ctx.stroke()
      }
      ctx.font = 'bold 22px Arial'
      ctx.textBaseline = 'middle'
      for (let i = 0; i < 4; i++) {
        ctx.fillStyle = `rgb(${30 + Math.floor(Math.random() * 80)},${30 + Math.floor(Math.random() * 80)},${30 + Math.floor(Math.random() * 80)})`
        const x = 12 + i * 20 + (Math.random() * 4 - 2)
        const y = h / 2 + (Math.random() * 6 - 3)
        ctx.save()
        ctx.translate(x, y)
        ctx.rotate((Math.random() * 0.4 - 0.2))
        ctx.fillText(code[i], 0, 0)
        ctx.restore()
      }
      for (let i = 0; i < 20; i++) {
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.3})`
        ctx.fillRect(Math.random() * w, Math.random() * h, 1, 1)
      }
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.submitting = true
        const payload = {
          type: this.form.type,
          title: this.form.title.trim(),
          content: this.form.content.trim(),
          name: this.form.name.trim(),
          phone: this.form.phone.trim(),
          address: this.form.address.trim()
        }
        submitMessage(payload)
          .then((res) => {
            const msg =
              (res && (res.msg || res.message)) || '提交成功，感谢您的反馈！'
            this.$message.success(msg)
            this.form.title = ''
            this.form.content = ''
            this.form.name = ''
            this.form.phone = ''
            this.form.address = ''
            this.form.captchaInput = ''
            this.refreshCaptcha()
            this.$refs.formRef.clearValidate()
          })
          .catch(() => {
            this.$message.error('提交失败，请稍后重试')
            this.refreshCaptcha()
            this.form.captchaInput = ''
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 640px;
}
.b-nav {
  width: 670px;
  height: 16px;
  display: flex;
  align-items: center;
  .location {
    font-family: 'SourceHanSansCN-Regular', sans-serif;
    font-size: 16px;
    color: #656565;
    margin-left: 7px;
  }
  .el-breadcrumb {
    margin-left: 10px;
    font-size: 16px;
    color: #656565;
    ::v-deep .is-link {
      font-weight: normal;
      color: #656565;
    }
    ::v-deep .is-link:hover {
      color: #d43e42;
      border-bottom: solid 1px #d43e42;
    }
  }
  img {
    width: 15px;
    height: 16px;
  }
}
.feedback-wrap {
  width: 100%;
  margin-top: 28px;
  padding-bottom: 48px;
  display: flex;
  justify-content: center;
  background: #e8e8e8;
  padding: 0 0 48px;
  border-radius: 2px;
}
.feedback-container {
  width: 100%;
  max-width: 100%;
}
.message-top-banner {
  width: 100%;
  margin-bottom: 24px;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}
.form-card {
  width: 640px;
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #ddd;
  box-sizing: border-box;
  padding: 36px 48px 40px;
}
.form-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 20px;
  color: #333;
  margin-bottom: 28px;
  font-weight: normal;
  i {
    font-size: 24px;
    color: #409eff;
  }
}
.feedback-form {
  ::v-deep .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-color: #ddd;
    border-radius: 2px;
    &::placeholder {
      color: #999;
    }
  }
}
.type-readonly {
  ::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border-color: #ddd;
    color: #606266;
    cursor: default;
  }
}
.field-with-star {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
}
.field-with-star--textarea {
  align-items: flex-start;
  .req-star {
    margin-top: 10px;
  }
}
.req-star {
  color: #f56c6c;
  flex-shrink: 0;
  font-size: 14px;
  line-height: 1;
  width: 14px;
  text-align: center;
  font-weight: normal;
}
.field-control {
  flex: 1;
  min-width: 0;
}
.captcha-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.captcha-input {
  flex: 1;
  min-width: 0;
}
.captcha-canvas {
  flex-shrink: 0;
  cursor: pointer;
  vertical-align: middle;
}
.captcha-row {
  margin-bottom: 8px;
}
.submit-btn {
  display: block;
  width: 200px;
  margin: 12px auto 0;
  height: 42px;
  font-size: 16px;
  border-radius: 4px;
  background: #409eff;
  border-color: #409eff;
}
</style>
